import type { LinkProps as MuiLinkProps } from "@mui/material/Link";
import MuiLink from "@mui/material/Link";
import { isDesktop } from "react-device-detect";
import { Link as RouterLink } from "react-router-dom";
import { OpenNewTabIcon } from "../Icons";
import { Typography, TypographyProps } from "../Typography/Typography";

import styles from "./Link.module.scss";

declare module "@mui/material/Link" {
    interface LinkPropsColorOverrides {
        primaryLink?: true;
    }
}

interface LinkProps extends Pick<MuiLinkProps, "target"> {
    children?: string;
    color?: "primary" | "error" | "inherit";
    href?: string;
    showNewTabIcon?: boolean;
    to?: string;
    variant?: TypographyProps["variant"];
}

export function Link({
    children,
    color = "primary",
    href,
    showNewTabIcon: showExternalIcon = false,
    to,
    target,
    variant = "text",
}: LinkProps) {
    return (
        <MuiLink
            className={styles["link"]}
            color={color === "primary" ? "primaryLink.main" : color}
            component={to ? RouterLink : "a"}
            href={href}
            target={target}
            to={to}
            underline={isDesktop ? "hover" : "always"}
        >
            <Typography component="span" fontWeight={600} variant={variant}>
                {children}
            </Typography>
            {target === "_blank" && showExternalIcon && (
                <span className={styles["new-tab-icon"]}>
                    <OpenNewTabIcon size="inherit" />
                </span>
            )}
        </MuiLink>
    );
}
